import React from 'react';
export const CodeIcon = () => {
  return <svg width="20" height="12" viewBox="0 0 20 12" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="CodeIcon" data-sentry-source-file="CodeIcon.tsx">
    <path d="M2.8 6L7.4 10.6L6 12L0 6L6 0L7.4 1.4L2.8 6ZM17.2 6L12.6 10.6L14 12L20 6L14 0L12.6 1.4L17.2 6Z" data-sentry-element="path" data-sentry-source-file="CodeIcon.tsx" />
    </svg>;
};